export const customStyles = {
  styles: (base: any) => ({
    ...base,
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '24px'
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: 'none'
  }),
  option: (base: any) => ({
    ...base,
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '24px',
    backgroundColor: 'none',
    color: 'black'
  }),
  control: (base: any) => ({
    ...base,
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '24px',
    border: '1px solid lightgray',
    '&:hover': {
      borderColor: 'lightgray'
    },
    boxShadow: 'none',
    padding: '6px 8px'
  }),
  multiValue: () => ({
    div: {
      display: 'inline'
    },
    'div:after': {
      content: '", "'
    }
  }),
  menu: (base: any) => ({
    ...base,
    borderColor: '#005C84',
    '&:hover': {
      borderColor: '#005C84'
    },
    boxShadow: '0 0 0 1px #005C84',
    margin: 0
  }),
  noOptionsMessage: () => ({
    display: 'none'
  })
};
